export const localizeStatus = (status, t)=>{
    switch(status){
        case 'active':
            return t.statusOptions.active();
        case 'scheduled':
            return t.statusOptions.scheduled();
        case 'archived':
            return t.statusOptions.archived();
        default:
            return t.statusLabel();
    }
};
export const isExcludeMode = (predicate)=>predicate.nin != null && predicate.nin.length > 0;
export const valueLabelFor = (predicate, t)=>{
    var _predicate_nin, _predicate_in;
    const values = isExcludeMode(predicate) ? (_predicate_nin = predicate.nin) !== null && _predicate_nin !== void 0 ? _predicate_nin : [] : (_predicate_in = predicate.in) !== null && _predicate_in !== void 0 ? _predicate_in : [];
    if (values.length === 0) return t.statusLabel();
    return values.map((status)=>localizeStatus(status, t)).join(', ');
};
